import { Component, OnInit, ViewChild } from '@angular/core';
import { TrialFormValue } from '../../models/trial-link.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CopyFeedbackPopupComponent } from 'src/app/shared/components';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'gdp-trial-link-voice',
  templateUrl: './trial-link-voice.component.html',
  styleUrls: ['./trial-link-voice.component.scss']
})
export class TrialLinkVoiceComponent implements OnInit {
  public modalContent: string = '';

  @ViewChild('trialVoiceLinkPopup', { static: false }) trialVoiceLinkPopup: CopyFeedbackPopupComponent;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void { }

  public generateLink(value: TrialFormValue): void {
    // this will allow to maintain the hour, min, secs of when the token is generated
    const date = new Date();
    // Set the corret day, month and year
    date.setFullYear(value.date.year, value.date.month - 1, value.date.day);
    value.date = date.getTime();
    this.modalService.open(this.trialVoiceLinkPopup, { size: 'lg' });
    switch (value.country.iso2.toUpperCase()) {
      case 'IT':
        this.modalContent = `${environment.trialLink.prefixItalian}?token=${btoa(JSON.stringify(value))}`;
        break;
      case 'GB':
        this.modalContent = `${environment.trialLink.prefixEnglish}?token=${btoa(JSON.stringify(value))}`;
        break;
      case 'US':
        this.modalContent = `${environment.trialLink.prefixEnglish}?token=${btoa(JSON.stringify(value))}&country=US`;
        break;
      default:
        this.modalContent = `${environment.trialLink.prefixEnglish}?token=${btoa(JSON.stringify(value))}`;
    }
  }
}
